import { render, staticRenderFns } from "./salesAmountTable.vue?vue&type=template&id=127187e4&scoped=true"
import script from "./salesAmountTable.vue?vue&type=script&lang=js"
export * from "./salesAmountTable.vue?vue&type=script&lang=js"
import style0 from "./salesAmountTable.vue?vue&type=style&index=0&id=127187e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127187e4",
  null
  
)

export default component.exports